import styles from './LanguageCircle.module.css'

export function LanguageCircle({color}: {color?: string}) {
  return (
    <span
      style={{backgroundColor: color || 'var(--bgColor-attention-emphasis)'}}
      className={styles.LanguageCircleIndicator}
    />
  )
}
